/**
 * Fallback: register stitched output in Video Library when stitch response omitted job_id.
 * @param {import("../../../context/GlobalContext").GlobalContextValue["hitAxios"]} hitAxios
 * @param {{
 *   output_url: string,
 *   stored?: string,
 *   output_filename?: string,
 *   total_duration?: number,
 *   output_resolution?: string,
 *   clip_count?: number,
 * }} payload
 */
export async function registerStitchInLibrary(hitAxios, payload) {
  const res = await hitAxios({
    path: "/api/video-studio/jobs/stitch-library",
    post: true,
    obj: payload,
    showLoading: false,
    showSnackbar: false,
  });

  if (!res?.data?.success) {
    const msg = res?.data?.msg || res?.error || "Could not add to library.";
    throw new Error(msg);
  }

  return res.data.data;
}
